<template>
  <div id="app">
    <AppModal />
    <NavBar />
    <InfoButton />
    <div class="app-content">
      <!-- <vue-page-transition name="fade"> -->
      <router-view :key="$route.fullPath" />
      <!-- </vue-page-transition> -->
    </div>
    <AppLoader />
    <Footer />
  </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import InfoButton from '@/components/InfoButton.vue'
import Footer from '@/components/Footer.vue'
import AppModal from '@/components/modal/AppModal.vue'
import AppLoader from '@/components/AppLoader.vue'

export default {
  name: 'App',
  components: {
    NavBar,
    Footer,
    AppModal,
    InfoButton,
    AppLoader
  },
  methods: {
    handleFirstTab(e) {
      if (e.keyCode === 9) {
        document.body.classList.add('user-is-tabbing')
        window.removeEventListener('keydown', this.handleFirstTab)
      }
    }
  },
  created() {
    window.addEventListener('keydown', this.handleFirstTab)
  },
  destroyed() {
    window.removeEventListener('keydown', this.handleFirstTab)
  }
}
</script>

<style lang="scss" scoped></style>
